import React, { memo } from 'react';
import { useParams } from 'react-router-dom';
import { StudentTable } from './StudentTable';
import { FeeStudentCategoryTable } from './FeeStudentCategoryTable';
import { AccountTransactionTable } from './AccountTransactionTable';
import NewAccountTransationTable from './NewAccountTransactionTable';
import AccountTransactionCategoryWise from './AccountTransactionCategoryWise';
import EncryptedStorage from 'core/utils/constants/encryptedStorage';


export const TablePrint = memo(() => {
  const params = useParams();
  const studentData = JSON.parse(EncryptedStorage.getItem('STUDENT_DATA') as string);
  const feeStudentCategoryData = JSON.parse(EncryptedStorage.getItem('FEE_STUDENT_CATEGORY_DATA') as string);
  const accountTransactionData = JSON.parse(localStorage.getItem('ACCOUNT_TRANSACION_DATA') as string);  

  const ModuleDisplay = () => {
    if (params.moduleName === 'student' && (studentData && studentData?.length > 0)) {
      return <StudentTable studentData={studentData} />;
    } else if (params?.moduleName === 'feeStudentCategory' && (feeStudentCategoryData && feeStudentCategoryData?.length > 0)){
      return <FeeStudentCategoryTable feeStudentCategoryData={feeStudentCategoryData} />
    } else if (params?.moduleName === 'accountTransaction'){
      return <NewAccountTransationTable aT={accountTransactionData} />
    } else if (params?.moduleName === 'accountTransactionCategoryWise'){
      return <AccountTransactionCategoryWise aT={accountTransactionData} />
    }
    return null;
  };

  return <>{ModuleDisplay()}</>;
});
